import type { FacetComponentProps } from 'components/search/FacetAccordion/FacetAccordion.types';
import { cn } from 'helpers/classnames';
import { getTestId } from 'utils/testing';

export const SwatchFacet = ({ label, count, isSelected, imgUrl, testId, onClick }: Extract<FacetComponentProps, { type: 'swatch' }>) => (
  <button
    type="button"
    onClick={onClick}
    aria-pressed={isSelected}
    data-test-id={getTestId(testId)}
    className={cn(
      'bg-white flex w-full items-center gap-2 md:gap-1.5 rounded-sm border px-2 md:px-1 py-3 text-left hover:bg-gray-50 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-900 focus-visible:ring-offset-2',
      isSelected ? 'border-gray-900 ring-1 ring-gray-900' : 'border-gray-300'
    )}
  >
    <span className="size-4 shrink-0 overflow-hidden rounded-full border border-gray-500">
      {imgUrl && <img src={imgUrl} alt="" className="size-full object-cover" />}
    </span>
    <span className="body-s truncate leading-none text-gray-900">{label}</span>
    <span className="body-xs ml-auto text-gray-500">{count}</span>
  </button>
);
